import { createQueryKeys } from "@lukemorales/query-key-factory";
import { MfListaObjekataPsPayload } from "./centralRegistry.types";

export const centralRegistryKeys = createQueryKeys("centralRegistry", {
  mfTipoviObjekata: () => ({
    queryKey: ["mf_tipovi_objekata"],
  }),
  mfListaObjekataPs: ({
    filters,
  }: {
    filters: Partial<MfListaObjekataPsPayload>;
  }) => ({
    queryKey: ["mf_lista_objekata_ps", filters],
  }),
});
